import { render, staticRenderFns } from "./CandidatesSearch.html?vue&type=template&id=bb6c72de&external"
import script from "./CandidatesSearch.ts?vue&type=script&lang=ts&external"
export * from "./CandidatesSearch.ts?vue&type=script&lang=ts&external"
import style0 from "./CandidatesSearch.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports